export enum FormTypes {
  REPAIRS = "naprawy",
  REPAIR = "naprawa",
  ESTIMATE = "wycena",
  ESTIMATES = "wyceny",
  SYMPTOMS = "objawy",
  GENERAL = "ogólny",
  ERROR = "błąd na stronie",
}

export type FormConfig = {
  header: string;
  subheader: string;
  textBoxHeader: string;
  hoverText: string;
  phoneButton: boolean;
};

export type FormConfigs = {
  [key in FormTypes]: FormConfig;
};

export const formsConfig: FormConfigs = {
  [FormTypes.REPAIRS]: {
    header: "Brakuje twojej naprawy na liście?",
    subheader: "Prześlij nam informację lub kosztorys do weryfikacji",
    textBoxHeader: "Jakiej naprawy brakuje?",
    hoverText:
      "Wpisz nazwę naprawy, której brakuje i model auta, w którym może występować, aby przyśpieszyć proces dodawania naprawy do naszej bazy",
    phoneButton: false,
  },
  [FormTypes.REPAIR]: {
    header: "Zapytaj eksperta o twój problem z samochodem",
    subheader: "",
    textBoxHeader: "Twoje pytanie",
    hoverText:
      "Opisz jak najlepiej problem. Jeśli nasz ekspert będzie miał wątpliwości, dopyta Cię o szczegóły poprzez e-mail. ",
    phoneButton: true,
  },
  [FormTypes.ESTIMATE]: {
    header: "Masz inną wycenę?",
    subheader: "Prześlij nam informację lub kosztorys do weryfikacji",
    textBoxHeader: "Jaką masz wycenę?",
    hoverText:
      "Opisz różnice w twojej wycenie podając których czynności lub części dotyczy, a najlepiej załącz zdjęcie wyceny do weryfikacji.",
    phoneButton: false,
  },
  [FormTypes.ESTIMATES]: {
    header: "Brakuje twojej naprawy na liście?",
    subheader: "Prześlij nam informację lub kosztorys do weryfikacji",
    textBoxHeader: "Jakiej naprawy brakuje?",
    hoverText:
      "Wpisz nazwę naprawy, której brakuje i model auta, w którym może występować, aby przyśpieszyć proces dodawania naprawy do naszej bazy",
    phoneButton: false,
  },
  [FormTypes.SYMPTOMS]: {
    header: "Brakuje twoich objawów na liście?",
    subheader: "Prześlij nam informację",
    textBoxHeader: "Jakich objawów brakuje?",
    hoverText:
      "Opisz w kilku słowach jaki objaw występuje u Ciebie. Staraj się w miarę możliwości opisać zarówno objawy jak i miejsce, w którym zostały zlokalizowane",
    phoneButton: false,
  },
  [FormTypes.GENERAL]: {
    header: "Zapytaj eksperta o twój problem z samochodem",
    subheader: "",
    textBoxHeader: "Twoje pytanie",
    hoverText:
      "Opisz jak najlepiej problem. Jeśli nasz ekspert będzie miał wątpliwości, dopyta Cię o szczegóły poprzez e-mail. ",
    phoneButton: true,
  },
  [FormTypes.ERROR]: {
    header: "Opowiedz nam co nie działa",
    subheader: "Dołożymy wszelkich starań by ci pomóc, a błąd naprawić.",
    textBoxHeader: "Twoje pytanie",
    hoverText:
      "Opisz jak najlepiej błąd który Ci się przytrafił. Pomoże nam to szybciej go zlokalizować",
    phoneButton: false,
  },
};
